import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchNewsItem } from "@/lib/api";
import { sanitize } from "@/lib/sanitize";
import { ChevronLeft, ExternalLink } from "lucide-react";

export default function NewsDetail() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { fetchNewsItem(id).then(setN); }, [id]);
  if (!n) return <div className="pt-24 text-white/60 text-center">Loading…</div>;
  return (
    <div className="pt-16" data-testid="news-detail-page">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-10">
        <Link to="/news" className="inline-flex items-center gap-1 text-white/60 hover:text-[#D4AF37] mb-6 text-sm"><ChevronLeft className="w-4 h-4"/>Back to News</Link>
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-3">{n.source}</p>
        <h1 className="font-heading text-3xl md:text-5xl font-bold leading-tight mb-4">{n.title}</h1>
        <p className="text-sm text-white/50 mb-8">{new Date(n.published_at).toLocaleString()} {n.author && `· by ${n.author}`}</p>
        {n.image_url && <img src={n.image_url} alt="" className="w-full rounded-2xl mb-8" onError={(e)=>e.target.style.display='none'} />}
        <div className="prose prose-invert text-white/85 leading-relaxed max-w-none [&_a]:text-[#D4AF37]" dangerouslySetInnerHTML={{__html: sanitize(n.body)}} />
        {n.external_url && (
          <a href={n.external_url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-8 btn-gold px-5 py-2.5 rounded-full text-sm font-semibold" data-testid="read-full-article">
            Read full article <ExternalLink className="w-4 h-4" />
          </a>
        )}
      </div>
    </div>
  );
}
